<template>
  <div class='header-base'>
    <v-layout justify-end wrap>
      <v-row justfiy='start' align='center'>
        <a @click="$router.push({path: '/tpc'})" style='color: black'><img height='50' src='../../../assets/TPC-Logo.png'><h1>TWISTY PUZZLE CUP</h1></a>
        <div style='text-align: left'>
          <a href='https://speedcubeshop.com/' target='_blank'><img height='50' src='../../../assets/SCS-Text-Logo.png'></a><br/>
        </div>
        <div style='text-align: left'>
          <a href='https://tiltify.com/@cuberslive/cuberslive-vs-cancer' target='_blank'><img height='50' src='../../../assets/ACS-Banner.png'></a><br/>
        </div>
      </v-row>
      <header-login :loggedIn="loggedIn" tpc />
      <v-btn v-if='adminAvailable' @click='goAdmin'>ADMIN</v-btn>
    </v-layout>
  </div>
</template>

<script>
import AdminService from '@/services/TPC/AdminService'

import HeaderLogin from '@/components/HeaderLogin'

export default {
  name: 'header-base',
  components: {
    HeaderLogin
  },
  data () {
    return {}
  },
  props: {
    id: String,
    pageType: String
  },
  methods: {
    goAdmin () {
      this.$router.push({path: `/tpc/admin`, query: this.$route.params})
    }
  },
  async created () {
    if (this.$store.state.loginSettings.loggedIn !== undefined) return
    let resp = await AdminService.verifyAdmin()
    this.$store.commit('setLoginSettings', {
      loggedIn: (resp.data && resp.data.error !== 'notAuthenticated'),
      adminAvailable: (resp.data && resp.data.success),
      profileID: (resp.data && resp.data.profileID),
    })
  },
  computed: {
    adminAvailable () {
      return this.$store.state.loginSettings.adminAvailable
    },
    loggedIn () {
      return this.$store.state.loginSettings.loggedIn
    }
  },
}
</script>

<style scoped>
.header-base {
  background-color: #f0f0f0;
  padding-top: 20px;
  margin-bottom: 10px;
}

h1 {
  display: inline-block;
  padding-left: 10px;
  font-size: 50px;
  font-weight: 500;
  font-family: 'Roboto', Helvetica, 'Arial', sans-serif;
}

@media only screen and (max-width: 1080px) {
  h1 {
    font-size: 30px;
  }
}

::v-deep .v-btn {
  margin: 6px 8px !important;
}

a {
  padding-left: 20px;
}
</style>
